import axios from "axios";
import myAppConfig from "../../../config";

const postSignUp = (send) => {
  console.log("SignUpFormService postSignUp send:", send);
  console.log("API Endpoint:", myAppConfig.api.ENDPOINT + "/api/v1/users/signup");
  
  return axios
    .post(myAppConfig.api.ENDPOINT + "/api/v1/users/signup", send)
    .then((response) => {
      return response;
    }).catch((error) => {
      console.error("ERROR in postSignUp:", error);
      console.error("Error response:", error.response);
      console.error("Error response data:", error.response?.data);
      console.error("Error response status:", error.response?.status);
      throw error;
    });
};

const DataService = {
  postSignUp,
};

export default DataService;
